<template>
	<div class="job-evaluation-verbs" v-if="verbsInfo && Object.keys(verbsInfo).length > 0">
		<div class="tabs tw-flex">
			<div
				v-for="(item, index) in verbsInfo"
				:key="index"
				class="tw-w-1/3 tw-text-center tab"
				@click="changeTab(index)"
				:class="{
					selected: currentTab === index,
					disabled: index !== filledLevel && filledLevel,
				}"
			>
				<p class="uppercase">{{ item && item.name ? item.name : '' }}</p>
			</div>
		</div>
		<div class="tw-px-8 tw-py-4 verbs-options">
			<div v-for="(item, commandKey) in verbsInfo" :key="commandKey">
				<div v-if="currentTab === commandKey" class="tw-flex tw-flex-wrap tw--mx-4">
					<div
						v-for="(verb, verbIndex) in item && item.details ? item.details : []"
						:key="verb && verb.code ? verb.code : verbIndex"
						class="tw-w-1/3 tw-px-4"
					>
						<v-checkbox
							v-if="verb && verb.code"
							v-model="safeJobCopied[commandKey][verb.code]"
							:label="verb.description || ''"
							:key="verbIndex"
							hide-details
							color="success"
							style="background: white"
							class="custom-checkbox"
							@change="onCheckboxChange(commandKey, verb.code, $event)"
						>
						</v-checkbox>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { head, keys, pipe, clone, values, prop, filter, any, equals, assoc, last } from 'ramda';
import { commandMap } from '@/modules/job-evaluation/utils/guideline-model/helpers';

export default {
	name: 'guideline-job-verbs-selector',
	props: {
		verbsInfo: {
			default: () => ({}),
		},
		selectedJob: {
			default: () => ({}),
		},
	},
	data() {
		return {
			currentTab: '',
			jobCopied: {
				highCommand: {},
				mediumCommand: {},
				lowCommand: {},
			},
		};
	},
	mounted() {
		if (this.verbsInfo && Object.keys(this.verbsInfo).length > 0) {
			this.currentTab = pipe(keys, head)(this.verbsInfo);
		}
	},
	computed: {
		filledLevel() {
			const levelsWithVerbs = pipe(
				keys,
				filter(levelKey => any(equals(true), values(prop(levelKey, this.safeJobCopied)))),
			)(this.verbsInfo);

			if (levelsWithVerbs.length === 0) return '';

			const priorityOrder = ['lowCommand', 'mediumCommand', 'highCommand'];
			return priorityOrder.find(level => levelsWithVerbs.includes(level)) || last(levelsWithVerbs);
		},
		typeVerbs() {
			return prop(this.filledLevel, commandMap);
		},
		safeJobCopied() {
			// Asegurar que jobCopied siempre tenga la estructura correcta
			return {
				highCommand: this.jobCopied.highCommand || {},
				mediumCommand: this.jobCopied.mediumCommand || {},
				lowCommand: this.jobCopied.lowCommand || {},
				...this.jobCopied,
			};
		},
	},
	watch: {
		selectedJob: {
			handler(val, prev) {
				if (val.name !== prev.name && this.verbsInfo && Object.keys(this.verbsInfo).length > 0) {
					this.currentTab = pipe(keys, head)(this.verbsInfo);
				}

				// Asegurar que jobCopied mantenga su estructura básica
				if (val && Object.keys(val).length > 0) {
					this.jobCopied = {
						highCommand: val.highCommand || {},
						mediumCommand: val.mediumCommand || {},
						lowCommand: val.lowCommand || {},
						...clone(val),
					};
				} else {
					// Si selectedJob está vacío, mantener la estructura básica
					this.jobCopied = {
						highCommand: {},
						mediumCommand: {},
						lowCommand: {},
					};
				}

				if (this.filledLevel) {
					this.currentTab = this.filledLevel;
				}
			},
		},
	},
	methods: {
		changeTab(index) {
			if (index !== this.filledLevel && this.filledLevel) return;
			this.currentTab = index;
		},
		onCheckboxChange(commandKey, verbCode, value) {
			if (!commandKey || !verbCode) {
				console.warn('onCheckboxChange called with invalid parameters:', {
					commandKey,
					verbCode,
					value,
				});
				return;
			}

			if (!this.jobCopied[commandKey]) {
				this.$set(this.jobCopied, commandKey, {});
			}

			this.$set(this.jobCopied[commandKey], verbCode, value);

			this.jobCopied = assoc('typeVerb', this.typeVerbs, this.jobCopied);
			this.$emit('selectedJobDataChanged', clone(this.jobCopied));
		},
	},
};
</script>

<style lang='scss' scoped>
.job-evaluation-verbs {
	border-top: solid 1px var(--app-color-gray);
	.tabs {
		user-select: none;
		.tab {
			padding-top: 20px;
			cursor: pointer;
			font-size: 12px;
			color: var(--app-color-primary);
			&.selected {
				border-bottom: solid 2px var(--app-color-primary);
			}
			&.disabled {
				cursor: not-allowed;
				color: var(--app-color-info);
			}
			border-bottom: solid 2px var(--app-color-gray);
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-evaluation/components/supplies/guideline-model/jobs-manager/job-info-edition/guideline-job-verbs-selector.vue